import { useState } from "react";
import { MapPin, Star, NavigationArrow, Clock, Phone } from "@phosphor-icons/react";
import { COMPANY } from "@/seo/data";

const MAP_EMBED_URL =
  "https://maps.google.com/maps?q=AutoGlas%20Erol%20GmbH%2C%20Frankenthaler%20Str.%2098%2C%2067059%20Ludwigshafen&z=15&output=embed";

export const LocationMap = () => {
  const [mapLoaded, setMapLoaded] = useState(false);

  return (
    <section id="werkstatt-anfahrt" className="py-16 md:py-20 bg-slate-50 border-t border-slate-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-10 items-center">
        <div>
          <p className="text-xs font-semibold text-blue-600 uppercase tracking-widest">Werkstatt &amp; Anfahrt</p>
          <h2 className="mt-3 text-2xl md:text-3xl font-bold text-slate-900 tracking-tight">
            Besuchen Sie uns in Ludwigshafen
          </h2>

          <a
            href={COMPANY.maps_url}
            target="_blank"
            rel="noreferrer"
            className="mt-5 inline-flex items-center gap-3 rounded-2xl bg-white border border-slate-200 shadow-sm px-5 py-3.5 hover:border-blue-300 transition-colors"
            data-testid="google-rating-badge"
          >
            <div className="flex items-center gap-0.5 text-amber-400">
              {[...Array(5)].map((_, i) => (
                <Star key={i} size={18} weight="fill" />
              ))}
            </div>
            <div className="text-sm">
              <span className="font-bold text-slate-900">{COMPANY.rating.toLocaleString("de-DE")}</span>
              <span className="text-slate-500"> · {COMPANY.rating_count} Google-Bewertungen</span>
            </div>
          </a>

          <div className="mt-6 space-y-3 text-slate-700">
            <div className="flex items-start gap-3">
              <MapPin size={20} weight="fill" className="text-blue-600 mt-0.5" />
              <div>
                <div className="font-semibold text-slate-900">AutoGlas Erol GmbH — Servus Autoglas</div>
                <div>Frankenthaler Str. 98, 67059 Ludwigshafen am Rhein</div>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <Clock size={20} weight="fill" className="text-blue-600 mt-0.5" />
              <div>Mo–Fr 09:00–18:00 Uhr · Sa 09:00–14:00 Uhr</div>
            </div>
            <div className="flex items-start gap-3">
              <Phone size={20} weight="fill" className="text-blue-600 mt-0.5" />
              <a href={`tel:${COMPANY.phone}`} className="hover:text-blue-700">{COMPANY.phone_display}</a>
            </div>
          </div>

          <a
            href={COMPANY.maps_url}
            target="_blank"
            rel="noreferrer"
            className="mt-7 inline-flex items-center gap-2 h-12 px-7 rounded-xl bg-blue-600 hover:bg-blue-700 text-white font-semibold transition-colors"
            data-testid="route-planen-button"
          >
            <NavigationArrow size={18} weight="fill" />
            Route planen mit Google Maps
          </a>
        </div>

        <div className="rounded-2xl overflow-hidden border border-slate-200 shadow-sm bg-white aspect-[4/3]">
          {mapLoaded ? (
            <iframe
              src={MAP_EMBED_URL}
              title="Google Maps — AutoGlas Erol GmbH, Frankenthaler Str. 98, Ludwigshafen"
              className="w-full h-full border-0"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
            />
          ) : (
            <button
              onClick={() => setMapLoaded(true)}
              className="w-full h-full flex flex-col items-center justify-center gap-3 bg-slate-100 hover:bg-slate-200 transition-colors p-6 text-center"
              data-testid="load-map-button"
            >
              <div className="w-16 h-16 rounded-full bg-blue-600 text-white flex items-center justify-center">
                <MapPin size={30} weight="fill" />
              </div>
              <div className="font-semibold text-slate-900">Karte anzeigen</div>
              <div className="text-xs text-slate-500 max-w-xs">
                Mit Klick wird Google Maps geladen. Dabei werden Daten an Google übertragen
                (siehe Datenschutzerklärung).
              </div>
            </button>
          )}
        </div>
      </div>
    </section>
  );
};

export default LocationMap;
